import { render, staticRenderFns } from "./PsychologicalAge.vue?vue&type=template&id=f6166260&scoped=true"
import script from "./PsychologicalAge.vue?vue&type=script&lang=js"
export * from "./PsychologicalAge.vue?vue&type=script&lang=js"
import style0 from "./PsychologicalAge.vue?vue&type=style&index=0&id=f6166260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6166260",
  null
  
)

export default component.exports